// BUILD=R21-orders-decoprof-only
import { useIsMobile } from "@/hooks/use-mobile";
import { Badge } from "@/components/ui/badge";
import { ShoppingCart, Radio } from "lucide-react";
import OrdersDecoprofTab from "@/components/orders/OrdersDecoprofTab";

const Orders = () => {
  const isMobile = useIsMobile();

  return (
    <div className={isMobile ? "space-y-3" : "space-y-6"}>
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <ShoppingCart className={`${isMobile ? "h-5 w-5" : "h-6 w-6"} text-primary`} />
          </div>
          <div>
            <h1 className={`${isMobile ? "text-lg" : "text-2xl"} font-bold`}>Orders Decoprof</h1>
            {!isMobile && (
              <p className="text-muted-foreground">
                Pakbonnen en statusbeheer voor Decoprof-orders
              </p>
            )}
          </div>
        </div>
        <Badge variant="outline" className="flex items-center gap-1.5">
          <Radio className="h-3 w-3 text-green-500 animate-pulse" />
          Live
        </Badge>
      </div>

      <OrdersDecoprofTab />
    </div>
  );
};

export default Orders;
